import * as React from "react";
import { Field, getIn, useFormikContext } from "formik";
import styled from "styled-components";
import { HoverForHelp } from "components/common";
import TextField from "views/components/aggregationwizard/visualization/configurationFields/TextField";
import BooleanField from "./configurationFields/BooleanField";
import NumericField from "./configurationFields/NumericField";
import SelectField from "./configurationFields/SelectField";
import MultiSelectField from "./configurationFields/MultiSelectField";
const TitleLabelWithHelp = styled.div`
  display: flex;
  align-items: center;
`;
const TitleHoverForHelp = styled((props) => /* @__PURE__ */ React.createElement(HoverForHelp, { ...props }))`
  margin-left: 5px;
`;
const componentForType = (type) => {
  switch (type) {
    case "select":
      return SelectField;
    case "boolean":
      return BooleanField;
    case "numeric":
      return NumericField;
    case "multi-select":
      return MultiSelectField;
    case "text":
      return TextField;
    default:
      throw new Error(`Invalid configuration field type: ${type}`);
  }
};
const titleForField = (field) => {
  const { helpComponent: HelpComponent } = field;
  return HelpComponent ? /* @__PURE__ */ React.createElement(TitleLabelWithHelp, null, field.title, /* @__PURE__ */ React.createElement(TitleHoverForHelp, { title: `Help for ${field.title}`, placement: "top" }, /* @__PURE__ */ React.createElement(HelpComponent, null))) : /* @__PURE__ */ React.createElement(React.Fragment, null, field.title);
};
const VisualizationConfigurationOptions = ({ name: namePrefix, fields }) => {
  const { values } = useFormikContext();
  const visualizationConfig = getIn(values, namePrefix);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, fields == null ? void 0 : fields.filter((field) => field.isShown ? field.isShown(visualizationConfig, values) : true).map((field) => {
    const title = titleForField(field);
    const inputHelp = typeof field.inputHelp === "function" ? field.inputHelp(visualizationConfig, values) : void 0;
    const fieldKey = `${namePrefix}.${field.name}`;
    const fieldName = `${namePrefix}.${field.name}`;
    if ((field == null ? void 0 : field.type) === "custom" && (field == null ? void 0 : field.component)) {
      const CustomFieldComponent = field.component;
      return /* @__PURE__ */ React.createElement(
        CustomFieldComponent,
        {
          key: fieldKey,
          name: fieldName,
          field,
          title,
          inputHelp,
          id: field.id
        }
      );
    }
    const Component = componentForType(field.type);
    return /* @__PURE__ */ React.createElement(Field, { key: fieldKey, name: fieldName }, ({ field: { name, value, onChange }, meta: { error } }) => /* @__PURE__ */ React.createElement(
      Component,
      {
        key: fieldKey,
        name,
        value,
        values,
        onChange,
        error,
        field,
        title,
        inputHelp
      }
    ));
  }));
};
export default VisualizationConfigurationOptions;
